/** Генерируется автоматически с помощью EnvconfigPlugin */
import { createEnvVar } from '@alfa-bank/site-envconfig-utils/helpers';

export const ALFAFORM_PIL_FLOW_API = createEnvVar(
    'ALFAFORM_PIL_FLOW_API',
    process.env.ALFAFORM_PIL_FLOW_API
);
export const ANKETA_MAIN_HOST = createEnvVar('ANKETA_MAIN_HOST', process.env.ANKETA_MAIN_HOST);
export const ATM_MAP_API_URL = createEnvVar('ATM_MAP_API_URL', process.env.ATM_MAP_API_URL);
export const ATM_MAP_URL_FALLBACK = createEnvVar(
    'ATM_MAP_URL_FALLBACK',
    process.env.ATM_MAP_URL_FALLBACK
);
export const AUTOCREDIT_APPOINTMENT_FORM_AVAILABLE_DATES = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_AVAILABLE_DATES',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_AVAILABLE_DATES
);
export const AUTOCREDIT_APPOINTMENT_FORM_CHECK_ADDRESS = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_CHECK_ADDRESS',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_CHECK_ADDRESS
);
export const AUTOCREDIT_APPOINTMENT_FORM_DELIVERY_AVAILABILITY = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_DELIVERY_AVAILABILITY',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_DELIVERY_AVAILABILITY
);
export const AUTOCREDIT_APPOINTMENT_FORM_SUGGEST_CITIES = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_SUGGEST_CITIES',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_SUGGEST_CITIES
);
export const BANANZA_PRIZES = createEnvVar('BANANZA_PRIZES', process.env.BANANZA_PRIZES);
export const BANDIT_URL = createEnvVar('BANDIT_URL', process.env.BANDIT_URL);
export const BASE_API_URL = createEnvVar('BASE_API_URL', process.env.BASE_API_URL);
export const BASE_API_URL_FOR_DEVELOPMENT = createEnvVar(
    'BASE_API_URL_FOR_DEVELOPMENT',
    process.env.BASE_API_URL_FOR_DEVELOPMENT
);
export const BIDDING_TENDERS = createEnvVar('BIDDING_TENDERS', process.env.BIDDING_TENDERS);
export const CC_PIGEONRY_API_URL_CANCEL = createEnvVar(
    'CC_PIGEONRY_API_URL_CANCEL',
    process.env.CC_PIGEONRY_API_URL_CANCEL
);
export const CC_PIGEONRY_API_URL_REQUESTS = createEnvVar(
    'CC_PIGEONRY_API_URL_REQUESTS',
    process.env.CC_PIGEONRY_API_URL_REQUESTS
);
export const CITIES = createEnvVar('CITIES', process.env.CITIES);
export const CITIES_GROUP = createEnvVar('CITIES_GROUP', process.env.CITIES_GROUP);
export const CITIES_GROUP_URL = createEnvVar('CITIES_GROUP_URL', process.env.CITIES_GROUP_URL);
export const CITIES_GROUP_URL_V2 = createEnvVar(
    'CITIES_GROUP_URL_V2',
    process.env.CITIES_GROUP_URL_V2
);
export const CITIES_URL = createEnvVar('CITIES_URL', process.env.CITIES_URL);
export const CITIES_URL_V2 = createEnvVar('CITIES_URL_V2', process.env.CITIES_URL_V2);
export const CITY_BY_IP_URL = createEnvVar('CITY_BY_IP_URL', process.env.CITY_BY_IP_URL);
export const CITY_BY_IP_URL_V2 = createEnvVar('CITY_BY_IP_URL_V2', process.env.CITY_BY_IP_URL_V2);
export const CORE_INPUT_ENABLE = createEnvVar('CORE_INPUT_ENABLE', process.env.CORE_INPUT_ENABLE);
export const CPAS_DADATA_PROXY = createEnvVar('CPAS_DADATA_PROXY', process.env.CPAS_DADATA_PROXY);
export const CPAS_DELIVERY_OF_SERVICES = createEnvVar(
    'CPAS_DELIVERY_OF_SERVICES',
    process.env.CPAS_DELIVERY_OF_SERVICES
);
export type TCpasDeliveryOfServicesAvailableDatesParams = {
    dateFrom: string | number;
    dateTo: string | number;
    deliveryUuid: string | number;
};
export const CPAS_DELIVERY_OF_SERVICES_AVAILABLE_DATES =
    createEnvVar<TCpasDeliveryOfServicesAvailableDatesParams>(
        'CPAS_DELIVERY_OF_SERVICES_AVAILABLE_DATES',
        process.env.CPAS_DELIVERY_OF_SERVICES_AVAILABLE_DATES
    );
export type TCpasDeliveryOfServicesBookingSlotParams = {
    uuid: string | number;
};
export const CPAS_DELIVERY_OF_SERVICES_BOOKING_SLOT =
    createEnvVar<TCpasDeliveryOfServicesBookingSlotParams>(
        'CPAS_DELIVERY_OF_SERVICES_BOOKING_SLOT',
        process.env.CPAS_DELIVERY_OF_SERVICES_BOOKING_SLOT
    );
export const CPAS_DELIVERY_OF_SERVICES_CODE_REQUEST = createEnvVar(
    'CPAS_DELIVERY_OF_SERVICES_CODE_REQUEST',
    process.env.CPAS_DELIVERY_OF_SERVICES_CODE_REQUEST
);
export const CPAS_DELIVERY_OF_SERVICES_CODE_VERIFICATION = createEnvVar(
    'CPAS_DELIVERY_OF_SERVICES_CODE_VERIFICATION',
    process.env.CPAS_DELIVERY_OF_SERVICES_CODE_VERIFICATION
);
export type TCpasDeliveryOfServicesConfirmationDeliveryParams = {
    uuid: string | number;
};
export const CPAS_DELIVERY_OF_SERVICES_CONFIRMATION_DELIVERY =
    createEnvVar<TCpasDeliveryOfServicesConfirmationDeliveryParams>(
        'CPAS_DELIVERY_OF_SERVICES_CONFIRMATION_DELIVERY',
        process.env.CPAS_DELIVERY_OF_SERVICES_CONFIRMATION_DELIVERY
    );
export type TCpasDeliveryOfServicesDeliveryAvailabilityParams = {
    accuracy: string | number;
    address: string | number;
    latitude: string | number;
    longitude: string | number;
    region: string | number;
};
export const CPAS_DELIVERY_OF_SERVICES_DELIVERY_AVAILABILITY =
    createEnvVar<TCpasDeliveryOfServicesDeliveryAvailabilityParams>(
        'CPAS_DELIVERY_OF_SERVICES_DELIVERY_AVAILABILITY',
        process.env.CPAS_DELIVERY_OF_SERVICES_DELIVERY_AVAILABILITY
    );
export const CPAS_DELIVERY_OF_SERVICES_DRAFTS = createEnvVar(
    'CPAS_DELIVERY_OF_SERVICES_DRAFTS',
    process.env.CPAS_DELIVERY_OF_SERVICES_DRAFTS
);
export const CYCLOPEDIA_ALL_ENTITIES = createEnvVar(
    'CYCLOPEDIA_ALL_ENTITIES',
    process.env.CYCLOPEDIA_ALL_ENTITIES
);
export const DADATA_PROXY_CLEAN_ADDRESS = createEnvVar(
    'DADATA_PROXY_CLEAN_ADDRESS',
    process.env.DADATA_PROXY_CLEAN_ADDRESS
);
export const DADATA_PROXY_FIND_BY_PARTY = createEnvVar(
    'DADATA_PROXY_FIND_BY_PARTY',
    process.env.DADATA_PROXY_FIND_BY_PARTY
);
export const DADATA_PROXY_GEOLOCATE_ADDRESS = createEnvVar(
    'DADATA_PROXY_GEOLOCATE_ADDRESS',
    process.env.DADATA_PROXY_GEOLOCATE_ADDRESS
);
export const DADATA_PROXY_SUGGEST_ADDRESS = createEnvVar(
    'DADATA_PROXY_SUGGEST_ADDRESS',
    process.env.DADATA_PROXY_SUGGEST_ADDRESS
);
export const DADATA_PROXY_SUGGEST_FIO = createEnvVar(
    'DADATA_PROXY_SUGGEST_FIO',
    process.env.DADATA_PROXY_SUGGEST_FIO
);
export const DADATA_PROXY_SUGGEST_FIO_TOKEN = createEnvVar(
    'DADATA_PROXY_SUGGEST_FIO_TOKEN',
    process.env.DADATA_PROXY_SUGGEST_FIO_TOKEN
);
export const DADATA_PROXY_SUGGEST_FMS_UNIT = createEnvVar(
    'DADATA_PROXY_SUGGEST_FMS_UNIT',
    process.env.DADATA_PROXY_SUGGEST_FMS_UNIT
);
export const DADATA_PROXY_SUGGEST_PARTY = createEnvVar(
    'DADATA_PROXY_SUGGEST_PARTY',
    process.env.DADATA_PROXY_SUGGEST_PARTY
);
export const DADATA_PROXY_URL = createEnvVar('DADATA_PROXY_URL', process.env.DADATA_PROXY_URL);
export const DADATA_SUGGEST_FIO = createEnvVar(
    'DADATA_SUGGEST_FIO',
    process.env.DADATA_SUGGEST_FIO
);
export const DADATA_SUGGEST_PARTY = createEnvVar(
    'DADATA_SUGGEST_PARTY',
    process.env.DADATA_SUGGEST_PARTY
);
export const DC_DRAFT = createEnvVar('DC_DRAFT', process.env.DC_DRAFT);
export const DC_DRAFT_FIRST_STEP = createEnvVar(
    'DC_DRAFT_FIRST_STEP',
    process.env.DC_DRAFT_FIRST_STEP
);
export const DC_FORM_ANKETA_PATH = createEnvVar(
    'DC_FORM_ANKETA_PATH',
    process.env.DC_FORM_ANKETA_PATH
);
export const DC_FORM_SENDER_APPLICATIONS = createEnvVar(
    'DC_FORM_SENDER_APPLICATIONS',
    process.env.DC_FORM_SENDER_APPLICATIONS
);
export type TDcFormSenderApplicationsCashbackCategoriesParams = {
    groupId: string | number;
    month: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_CASHBACK_CATEGORIES =
    createEnvVar<TDcFormSenderApplicationsCashbackCategoriesParams>(
        'DC_FORM_SENDER_APPLICATIONS_CASHBACK_CATEGORIES',
        process.env.DC_FORM_SENDER_APPLICATIONS_CASHBACK_CATEGORIES
    );
export type TDcFormSenderApplicationsCodesDeliveryResendParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_RESEND =
    createEnvVar<TDcFormSenderApplicationsCodesDeliveryResendParams>(
        'DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_RESEND',
        process.env.DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_RESEND
    );
export type TDcFormSenderApplicationsCodesDeliveryVerifyParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_VERIFY =
    createEnvVar<TDcFormSenderApplicationsCodesDeliveryVerifyParams>(
        'DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_VERIFY',
        process.env.DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_VERIFY
    );
export type TDcFormSenderApplicationsCodesResendParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_CODES_RESEND =
    createEnvVar<TDcFormSenderApplicationsCodesResendParams>(
        'DC_FORM_SENDER_APPLICATIONS_CODES_RESEND',
        process.env.DC_FORM_SENDER_APPLICATIONS_CODES_RESEND
    );
export type TDcFormSenderApplicationsCodesVerifyParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_CODES_VERIFY =
    createEnvVar<TDcFormSenderApplicationsCodesVerifyParams>(
        'DC_FORM_SENDER_APPLICATIONS_CODES_VERIFY',
        process.env.DC_FORM_SENDER_APPLICATIONS_CODES_VERIFY
    );
export type TDcFormSenderApplicationsDeliveriesSearchParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_DELIVERIES_SEARCH =
    createEnvVar<TDcFormSenderApplicationsDeliveriesSearchParams>(
        'DC_FORM_SENDER_APPLICATIONS_DELIVERIES_SEARCH',
        process.env.DC_FORM_SENDER_APPLICATIONS_DELIVERIES_SEARCH
    );
export type TDcFormSenderApplicationsDeliveriesTimeSlotsParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_DELIVERIES_TIME_SLOTS =
    createEnvVar<TDcFormSenderApplicationsDeliveriesTimeSlotsParams>(
        'DC_FORM_SENDER_APPLICATIONS_DELIVERIES_TIME_SLOTS',
        process.env.DC_FORM_SENDER_APPLICATIONS_DELIVERIES_TIME_SLOTS
    );
export type TDcFormSenderApplicationsDraftsCheckParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_DRAFTS_CHECK =
    createEnvVar<TDcFormSenderApplicationsDraftsCheckParams>(
        'DC_FORM_SENDER_APPLICATIONS_DRAFTS_CHECK',
        process.env.DC_FORM_SENDER_APPLICATIONS_DRAFTS_CHECK
    );
export type TDcFormSenderApplicationsFinishParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_FINISH =
    createEnvVar<TDcFormSenderApplicationsFinishParams>(
        'DC_FORM_SENDER_APPLICATIONS_FINISH',
        process.env.DC_FORM_SENDER_APPLICATIONS_FINISH
    );
export type TDcFormSenderApplicationsPassportParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_PASSPORT =
    createEnvVar<TDcFormSenderApplicationsPassportParams>(
        'DC_FORM_SENDER_APPLICATIONS_PASSPORT',
        process.env.DC_FORM_SENDER_APPLICATIONS_PASSPORT
    );
export type TDcFormSenderApplicationsRestoreDraftParams = {
    draftId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_RESTORE_DRAFT =
    createEnvVar<TDcFormSenderApplicationsRestoreDraftParams>(
        'DC_FORM_SENDER_APPLICATIONS_RESTORE_DRAFT',
        process.env.DC_FORM_SENDER_APPLICATIONS_RESTORE_DRAFT
    );
export const DEPOSITARY_NEWS_NEWS = createEnvVar(
    'DEPOSITARY_NEWS_NEWS',
    process.env.DEPOSITARY_NEWS_NEWS
);
export const DEPOSITARY_NEWS_PUBLICATION_DATES = createEnvVar(
    'DEPOSITARY_NEWS_PUBLICATION_DATES',
    process.env.DEPOSITARY_NEWS_PUBLICATION_DATES
);
export const EMAIL_FIELD = createEnvVar('EMAIL_FIELD', process.env.EMAIL_FIELD);
export const EXCHANGE_RATES_API_URL = createEnvVar(
    'EXCHANGE_RATES_API_URL',
    process.env.EXCHANGE_RATES_API_URL
);
export const FEEDBACK_FEEDBACKS = createEnvVar(
    'FEEDBACK_FEEDBACKS',
    process.env.FEEDBACK_FEEDBACKS
);
export const FORMS_CONSUMER_FORMS = createEnvVar(
    'FORMS_CONSUMER_FORMS',
    process.env.FORMS_CONSUMER_FORMS
);
export const GEO_CITIES_URL = createEnvVar('GEO_CITIES_URL', process.env.GEO_CITIES_URL);
export const GRAPHQL_API_URL = createEnvVar('GRAPHQL_API_URL', process.env.GRAPHQL_API_URL);
export const GRAPHQL_URL_FALLBACK = createEnvVar(
    'GRAPHQL_URL_FALLBACK',
    process.env.GRAPHQL_URL_FALLBACK
);
export const ISSUE_REPORTS_NEWS = createEnvVar(
    'ISSUE_REPORTS_NEWS',
    process.env.ISSUE_REPORTS_NEWS
);
export const MAGNETO_METALS = createEnvVar('MAGNETO_METALS', process.env.MAGNETO_METALS);
export const MAPS_DADATA_PROXY = createEnvVar('MAPS_DADATA_PROXY', process.env.MAPS_DADATA_PROXY);
export const MORTGAGE_API_HOST = createEnvVar('MORTGAGE_API_HOST', process.env.MORTGAGE_API_HOST);
export const MORTGAGE_FORM_HOST = createEnvVar(
    'MORTGAGE_FORM_HOST',
    process.env.MORTGAGE_FORM_HOST
);
export const MORTGAGE_FORM_REGIONS = createEnvVar(
    'MORTGAGE_FORM_REGIONS',
    process.env.MORTGAGE_FORM_REGIONS
);
export const OFFERS_CLIENT_URL = createEnvVar('OFFERS_CLIENT_URL', process.env.OFFERS_CLIENT_URL);
export const OFFERS_CODES_URL = createEnvVar('OFFERS_CODES_URL', process.env.OFFERS_CODES_URL);
export const OFFERS_URL = createEnvVar('OFFERS_URL', process.env.OFFERS_URL);
export const OFFICES_MAP_API_URL = createEnvVar(
    'OFFICES_MAP_API_URL',
    process.env.OFFICES_MAP_API_URL
);
export const OFFICES_MAP_URL_FALLBACK = createEnvVar(
    'OFFICES_MAP_URL_FALLBACK',
    process.env.OFFICES_MAP_URL_FALLBACK
);
export type TPilAdditionalInfoEkkParams = {
    applicationUuid: string | number;
};
export const PIL_ADDITIONAL_INFO_EKK = createEnvVar<TPilAdditionalInfoEkkParams>(
    'PIL_ADDITIONAL_INFO_EKK',
    process.env.PIL_ADDITIONAL_INFO_EKK
);
export type TPilApplicationsEkkParams = {
    applicationUuid: string | number;
};
export const PIL_APPLICATIONS_EKK = createEnvVar<TPilApplicationsEkkParams>(
    'PIL_APPLICATIONS_EKK',
    process.env.PIL_APPLICATIONS_EKK
);
export type TPilBackStepEkkParams = {
    applicationUuid: string | number;
};
export const PIL_BACK_STEP_EKK = createEnvVar<TPilBackStepEkkParams>(
    'PIL_BACK_STEP_EKK',
    process.env.PIL_BACK_STEP_EKK
);
export const PIL_CERBERUS_CROSS_AUTH = createEnvVar(
    'PIL_CERBERUS_CROSS_AUTH',
    process.env.PIL_CERBERUS_CROSS_AUTH
);
export type TPilCerberusRedirectLinkParams = {
    firstName: string | number;
    lastName: string | number;
    middleName: string | number;
    mobilePhone: string | number;
};
export const PIL_CERBERUS_REDIRECT_LINK = createEnvVar<TPilCerberusRedirectLinkParams>(
    'PIL_CERBERUS_REDIRECT_LINK',
    process.env.PIL_CERBERUS_REDIRECT_LINK
);
export type TPilCompletionEkkParams = {
    count: string | number;
    query: string | number;
    strategy: string | number;
    subject: string | number;
};
export const PIL_COMPLETION_EKK = createEnvVar<TPilCompletionEkkParams>(
    'PIL_COMPLETION_EKK',
    process.env.PIL_COMPLETION_EKK
);
export type TPilContinueEkkParams = {
    applicationUuid: string | number;
};
export const PIL_CONTINUE_EKK = createEnvVar<TPilContinueEkkParams>(
    'PIL_CONTINUE_EKK',
    process.env.PIL_CONTINUE_EKK
);
export type TPilCreditParamsEkkParams = {
    applicationUuid: string | number;
};
export const PIL_CREDIT_PARAMS_EKK = createEnvVar<TPilCreditParamsEkkParams>(
    'PIL_CREDIT_PARAMS_EKK',
    process.env.PIL_CREDIT_PARAMS_EKK
);
export type TPilDeliveryInfoEkkParams = {
    applicationUuid: string | number;
};
export const PIL_DELIVERY_INFO_EKK = createEnvVar<TPilDeliveryInfoEkkParams>(
    'PIL_DELIVERY_INFO_EKK',
    process.env.PIL_DELIVERY_INFO_EKK
);
export type TPilDigitalProfileEkkParams = {
    applicationUuid: string | number;
};
export const PIL_DIGITAL_PROFILE_EKK = createEnvVar<TPilDigitalProfileEkkParams>(
    'PIL_DIGITAL_PROFILE_EKK',
    process.env.PIL_DIGITAL_PROFILE_EKK
);
export type TPilDigitalProfileSessionInfoEkkParams = {
    applicationUuid: string | number;
};
export const PIL_DIGITAL_PROFILE_SESSION_INFO_EKK =
    createEnvVar<TPilDigitalProfileSessionInfoEkkParams>(
        'PIL_DIGITAL_PROFILE_SESSION_INFO_EKK',
        process.env.PIL_DIGITAL_PROFILE_SESSION_INFO_EKK
    );
export type TPilDraftEkkParams = {
    applicationUuid: string | number;
};
export const PIL_DRAFT_EKK = createEnvVar<TPilDraftEkkParams>(
    'PIL_DRAFT_EKK',
    process.env.PIL_DRAFT_EKK
);
export type TPilEducationStatusEkkParams = {
    applicationUuid: string | number;
};
export const PIL_EDUCATION_STATUS_EKK = createEnvVar<TPilEducationStatusEkkParams>(
    'PIL_EDUCATION_STATUS_EKK',
    process.env.PIL_EDUCATION_STATUS_EKK
);
export type TPilEsiaIndividualUuidParams = {
    applicationUuid: string | number;
};
export const PIL_ESIA_INDIVIDUAL_UUID = createEnvVar<TPilEsiaIndividualUuidParams>(
    'PIL_ESIA_INDIVIDUAL_UUID',
    process.env.PIL_ESIA_INDIVIDUAL_UUID
);
export const PIL_ESIA_USER_INFO = createEnvVar(
    'PIL_ESIA_USER_INFO',
    process.env.PIL_ESIA_USER_INFO
);
export const PIL_INIT_AUTH_EKK = createEnvVar('PIL_INIT_AUTH_EKK', process.env.PIL_INIT_AUTH_EKK);
export type TPilInitClientEkkParams = {
    applicationUuid: string | number;
};
export const PIL_INIT_CLIENT_EKK = createEnvVar<TPilInitClientEkkParams>(
    'PIL_INIT_CLIENT_EKK',
    process.env.PIL_INIT_CLIENT_EKK
);
export const PIL_INIT_EKK = createEnvVar('PIL_INIT_EKK', process.env.PIL_INIT_EKK);
export type TPilMoveToDraftEkkParams = {
    applicationUuid: string | number;
};
export const PIL_MOVE_TO_DRAFT_EKK = createEnvVar<TPilMoveToDraftEkkParams>(
    'PIL_MOVE_TO_DRAFT_EKK',
    process.env.PIL_MOVE_TO_DRAFT_EKK
);
export type TPilNextStepEkkParams = {
    applicationUuid: string | number;
};
export const PIL_NEXT_STEP_EKK = createEnvVar<TPilNextStepEkkParams>(
    'PIL_NEXT_STEP_EKK',
    process.env.PIL_NEXT_STEP_EKK
);
export const PIL_OCRM_REDIRECT_LINK = createEnvVar(
    'PIL_OCRM_REDIRECT_LINK',
    process.env.PIL_OCRM_REDIRECT_LINK
);
export type TPilOffersEkkParams = {
    applicationUuid: string | number;
};
export const PIL_OFFERS_EKK = createEnvVar<TPilOffersEkkParams>(
    'PIL_OFFERS_EKK',
    process.env.PIL_OFFERS_EKK
);
export type TPilOfferOcrmEkkParams = {
    applicationUuid: string | number;
};
export const PIL_OFFER_OCRM_EKK = createEnvVar<TPilOfferOcrmEkkParams>(
    'PIL_OFFER_OCRM_EKK',
    process.env.PIL_OFFER_OCRM_EKK
);
export const PIL_OFFICES_GRAPHQL = createEnvVar(
    'PIL_OFFICES_GRAPHQL',
    process.env.PIL_OFFICES_GRAPHQL
);
export type TPilPassportEkkParams = {
    applicationUuid: string | number;
};
export const PIL_PASSPORT_EKK = createEnvVar<TPilPassportEkkParams>(
    'PIL_PASSPORT_EKK',
    process.env.PIL_PASSPORT_EKK
);
export type TPilSendOfferEkkParams = {
    applicationUuid: string | number;
};
export const PIL_SEND_OFFER_EKK = createEnvVar<TPilSendOfferEkkParams>(
    'PIL_SEND_OFFER_EKK',
    process.env.PIL_SEND_OFFER_EKK
);
export type TPilWorkInfoEkkParams = {
    applicationUuid: string | number;
};
export const PIL_WORK_INFO_EKK = createEnvVar<TPilWorkInfoEkkParams>(
    'PIL_WORK_INFO_EKK',
    process.env.PIL_WORK_INFO_EKK
);
export type TPressNewsItemParams = {
    path: string | number;
};
export const PRESS_NEWS_ITEM = createEnvVar<TPressNewsItemParams>(
    'PRESS_NEWS_ITEM',
    process.env.PRESS_NEWS_ITEM
);
export const PRESS_NEWS_LIST = createEnvVar('PRESS_NEWS_LIST', process.env.PRESS_NEWS_LIST);
export const PRESS_NEWS_PUBLICATION_TYPES = createEnvVar(
    'PRESS_NEWS_PUBLICATION_TYPES',
    process.env.PRESS_NEWS_PUBLICATION_TYPES
);
export const PRESS_NEWS_TAGS = createEnvVar('PRESS_NEWS_TAGS', process.env.PRESS_NEWS_TAGS);
export const PROMO_CARDS_ENDPOINT = createEnvVar(
    'PROMO_CARDS_ENDPOINT',
    process.env.PROMO_CARDS_ENDPOINT
);
export const RECAPTCHA_KEY = createEnvVar('RECAPTCHA_KEY', process.env.RECAPTCHA_KEY);
export const RECOGNITION_UTM_URL = createEnvVar(
    'RECOGNITION_UTM_URL',
    process.env.RECOGNITION_UTM_URL
);
export const ROUPER_PERSONALIZATION_URL = createEnvVar(
    'ROUPER_PERSONALIZATION_URL',
    process.env.ROUPER_PERSONALIZATION_URL
);
export type TSalaryCityOfficeListParams = {
    appUuid: string | number;
};
export const SALARY_CITY_OFFICE_LIST = createEnvVar<TSalaryCityOfficeListParams>(
    'SALARY_CITY_OFFICE_LIST',
    process.env.SALARY_CITY_OFFICE_LIST
);
export type TSalaryClientDataParams = {
    draftId: string | number;
};
export const SALARY_CLIENT_DATA = createEnvVar<TSalaryClientDataParams>(
    'SALARY_CLIENT_DATA',
    process.env.SALARY_CLIENT_DATA
);
export type TSalaryCodesRequestParams = {
    appUuid: string | number;
};
export const SALARY_CODES_REQUEST = createEnvVar<TSalaryCodesRequestParams>(
    'SALARY_CODES_REQUEST',
    process.env.SALARY_CODES_REQUEST
);
export type TSalaryCodesVerifyParams = {
    appUuid: string | number;
};
export const SALARY_CODES_VERIFY = createEnvVar<TSalaryCodesVerifyParams>(
    'SALARY_CODES_VERIFY',
    process.env.SALARY_CODES_VERIFY
);
export const SALARY_DADATA_PROXY = createEnvVar(
    'SALARY_DADATA_PROXY',
    process.env.SALARY_DADATA_PROXY
);
export type TSalaryDeliveryBranchParams = {
    appUuid: string | number;
};
export const SALARY_DELIVERY_BRANCH = createEnvVar<TSalaryDeliveryBranchParams>(
    'SALARY_DELIVERY_BRANCH',
    process.env.SALARY_DELIVERY_BRANCH
);
export type TSalaryDeliveryCheckParams = {
    appUuid: string | number;
};
export const SALARY_DELIVERY_CHECK = createEnvVar<TSalaryDeliveryCheckParams>(
    'SALARY_DELIVERY_CHECK',
    process.env.SALARY_DELIVERY_CHECK
);
export type TSalaryDeliverySlotsParams = {
    appUuid: string | number;
};
export const SALARY_DELIVERY_SLOTS = createEnvVar<TSalaryDeliverySlotsParams>(
    'SALARY_DELIVERY_SLOTS',
    process.env.SALARY_DELIVERY_SLOTS
);
export type TSalaryDeliverySlotApproveParams = {
    appUuid: string | number;
};
export const SALARY_DELIVERY_SLOT_APPROVE = createEnvVar<TSalaryDeliverySlotApproveParams>(
    'SALARY_DELIVERY_SLOT_APPROVE',
    process.env.SALARY_DELIVERY_SLOT_APPROVE
);
export const SHERLOCK_SITE_SEARCH = createEnvVar(
    'SHERLOCK_SITE_SEARCH',
    process.env.SHERLOCK_SITE_SEARCH
);
export type TSmenderParams = {
    patch: string | number;
};
export const SMENDER = createEnvVar<TSmenderParams>('SMENDER', process.env.SMENDER);
export type TSmeAcqGetTariffsParams = {
    limit: string | number;
    offset: string | number;
    sort: string | number;
};
export const SME_ACQ_GET_TARIFFS = createEnvVar<TSmeAcqGetTariffsParams>(
    'SME_ACQ_GET_TARIFFS',
    process.env.SME_ACQ_GET_TARIFFS
);
export const SME_ACQ_HELPDESKEDDY_TESTING_SCRIPT = createEnvVar(
    'SME_ACQ_HELPDESKEDDY_TESTING_SCRIPT',
    process.env.SME_ACQ_HELPDESKEDDY_TESTING_SCRIPT
);
export type TSmeAcqStonksParams = {
    patch: string | number;
};
export const SME_ACQ_STONKS = createEnvVar<TSmeAcqStonksParams>(
    'SME_ACQ_STONKS',
    process.env.SME_ACQ_STONKS
);
export const SME_AR_FORM_SENDER_RKO_APPLICATIONS = createEnvVar(
    'SME_AR_FORM_SENDER_RKO_APPLICATIONS',
    process.env.SME_AR_FORM_SENDER_RKO_APPLICATIONS
);
export type TSmeArFormSenderRkoApplicationsChoosingCompanyParams = {
    appUuid: string | number;
};
export const SME_AR_FORM_SENDER_RKO_APPLICATIONS_CHOOSING_COMPANY =
    createEnvVar<TSmeArFormSenderRkoApplicationsChoosingCompanyParams>(
        'SME_AR_FORM_SENDER_RKO_APPLICATIONS_CHOOSING_COMPANY',
        process.env.SME_AR_FORM_SENDER_RKO_APPLICATIONS_CHOOSING_COMPANY
    );
export type TSmeArFormSenderRkoApplicationsDeliveryParams = {
    appUuid: string | number;
};
export const SME_AR_FORM_SENDER_RKO_APPLICATIONS_DELIVERY =
    createEnvVar<TSmeArFormSenderRkoApplicationsDeliveryParams>(
        'SME_AR_FORM_SENDER_RKO_APPLICATIONS_DELIVERY',
        process.env.SME_AR_FORM_SENDER_RKO_APPLICATIONS_DELIVERY
    );
export type TSmeArFormSenderRkoApplicationsDeliveryTimeSlotsParams = {
    appUuid: string | number;
    gte: string | number;
    limit: string | number;
    lte: string | number;
};
export const SME_AR_FORM_SENDER_RKO_APPLICATIONS_DELIVERY_TIME_SLOTS =
    createEnvVar<TSmeArFormSenderRkoApplicationsDeliveryTimeSlotsParams>(
        'SME_AR_FORM_SENDER_RKO_APPLICATIONS_DELIVERY_TIME_SLOTS',
        process.env.SME_AR_FORM_SENDER_RKO_APPLICATIONS_DELIVERY_TIME_SLOTS
    );
export const SME_AR_FORM_SENDER_RKO_APPLICATIONS_INIT = createEnvVar(
    'SME_AR_FORM_SENDER_RKO_APPLICATIONS_INIT',
    process.env.SME_AR_FORM_SENDER_RKO_APPLICATIONS_INIT
);
export type TSmeArFormSenderRkoApplicationsProductsParams = {
    appUuid: string | number;
};
export const SME_AR_FORM_SENDER_RKO_APPLICATIONS_PRODUCTS =
    createEnvVar<TSmeArFormSenderRkoApplicationsProductsParams>(
        'SME_AR_FORM_SENDER_RKO_APPLICATIONS_PRODUCTS',
        process.env.SME_AR_FORM_SENDER_RKO_APPLICATIONS_PRODUCTS
    );
export type TSmeArFormSenderRkoApplicationsReserveCompanyAccountParams = {
    appUuid: string | number;
};
export const SME_AR_FORM_SENDER_RKO_APPLICATIONS_RESERVE_COMPANY_ACCOUNT =
    createEnvVar<TSmeArFormSenderRkoApplicationsReserveCompanyAccountParams>(
        'SME_AR_FORM_SENDER_RKO_APPLICATIONS_RESERVE_COMPANY_ACCOUNT',
        process.env.SME_AR_FORM_SENDER_RKO_APPLICATIONS_RESERVE_COMPANY_ACCOUNT
    );
export type TSmeArFormSenderRkoApplicationsSkipDeliveryParams = {
    appUuid: string | number;
};
export const SME_AR_FORM_SENDER_RKO_APPLICATIONS_SKIP_DELIVERY =
    createEnvVar<TSmeArFormSenderRkoApplicationsSkipDeliveryParams>(
        'SME_AR_FORM_SENDER_RKO_APPLICATIONS_SKIP_DELIVERY',
        process.env.SME_AR_FORM_SENDER_RKO_APPLICATIONS_SKIP_DELIVERY
    );
export type TSmeArFormSenderRkoApplicationsWithidParams = {
    appUuid: string | number;
};
export const SME_AR_FORM_SENDER_RKO_APPLICATIONS_WITHID =
    createEnvVar<TSmeArFormSenderRkoApplicationsWithidParams>(
        'SME_AR_FORM_SENDER_RKO_APPLICATIONS_WITHID',
        process.env.SME_AR_FORM_SENDER_RKO_APPLICATIONS_WITHID
    );
export const SME_AR_FORM_SENDER_RKO_AUTHENTICATE = createEnvVar(
    'SME_AR_FORM_SENDER_RKO_AUTHENTICATE',
    process.env.SME_AR_FORM_SENDER_RKO_AUTHENTICATE
);
export const SME_AR_FORM_SENDER_RKO_CODES_REQUEST = createEnvVar(
    'SME_AR_FORM_SENDER_RKO_CODES_REQUEST',
    process.env.SME_AR_FORM_SENDER_RKO_CODES_REQUEST
);
export type TSmeArFormSenderRkoDeliveryInfoParams = {
    appUuid: string | number;
};
export const SME_AR_FORM_SENDER_RKO_DELIVERY_INFO =
    createEnvVar<TSmeArFormSenderRkoDeliveryInfoParams>(
        'SME_AR_FORM_SENDER_RKO_DELIVERY_INFO',
        process.env.SME_AR_FORM_SENDER_RKO_DELIVERY_INFO
    );
export const SME_AR_FORM_SENDER_RKO_DELIVERY_ZONES = createEnvVar(
    'SME_AR_FORM_SENDER_RKO_DELIVERY_ZONES',
    process.env.SME_AR_FORM_SENDER_RKO_DELIVERY_ZONES
);
export const SME_AR_FORM_SENDER_RKO_TOKENS_CHECK = createEnvVar(
    'SME_AR_FORM_SENDER_RKO_TOKENS_CHECK',
    process.env.SME_AR_FORM_SENDER_RKO_TOKENS_CHECK
);
export type TSmeArYaMapParams = {
    apiKey: string | number;
};
export const SME_AR_YA_MAP = createEnvVar<TSmeArYaMapParams>(
    'SME_AR_YA_MAP',
    process.env.SME_AR_YA_MAP
);
export type TSmeCitiesOfPresenceParams = {
    geoGroupsList: string | number;
};
export const SME_CITIES_OF_PRESENCE = createEnvVar<TSmeCitiesOfPresenceParams>(
    'SME_CITIES_OF_PRESENCE',
    process.env.SME_CITIES_OF_PRESENCE
);
export const SME_CREDITS_LOAN_FORM_APPLICATIONS_AVAILABILITY_CHECK = createEnvVar(
    'SME_CREDITS_LOAN_FORM_APPLICATIONS_AVAILABILITY_CHECK',
    process.env.SME_CREDITS_LOAN_FORM_APPLICATIONS_AVAILABILITY_CHECK
);
export type TSmeCreditsLoanFormApplicationsUuidDeliveriesRkoConfirmationParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DELIVERIES_RKO_CONFIRMATION =
    createEnvVar<TSmeCreditsLoanFormApplicationsUuidDeliveriesRkoConfirmationParams>(
        'SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DELIVERIES_RKO_CONFIRMATION',
        process.env.SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DELIVERIES_RKO_CONFIRMATION
    );
export type TSmeCreditsLoanFormApplicationsUuidDeliveriesRkoDraftsParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DELIVERIES_RKO_DRAFTS =
    createEnvVar<TSmeCreditsLoanFormApplicationsUuidDeliveriesRkoDraftsParams>(
        'SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DELIVERIES_RKO_DRAFTS',
        process.env.SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DELIVERIES_RKO_DRAFTS
    );
export type TSmeCreditsLoanFormApplicationsUuidDeliveriesRkoTimeslotsParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DELIVERIES_RKO_TIMESLOTS =
    createEnvVar<TSmeCreditsLoanFormApplicationsUuidDeliveriesRkoTimeslotsParams>(
        'SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DELIVERIES_RKO_TIMESLOTS',
        process.env.SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DELIVERIES_RKO_TIMESLOTS
    );
export type TSmeCreditsLoanFormApplicationsUuidDocumentsDocumentuuidParams = {
    documentUuid: string | number;
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DOCUMENTS_DOCUMENTUUID =
    createEnvVar<TSmeCreditsLoanFormApplicationsUuidDocumentsDocumentuuidParams>(
        'SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DOCUMENTS_DOCUMENTUUID',
        process.env.SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_DOCUMENTS_DOCUMENTUUID
    );
export type TSmeCreditsLoanFormApplicationsUuidIndividualOwnerParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_INDIVIDUAL_OWNER =
    createEnvVar<TSmeCreditsLoanFormApplicationsUuidIndividualOwnerParams>(
        'SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_INDIVIDUAL_OWNER',
        process.env.SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_INDIVIDUAL_OWNER
    );
export type TSmeCreditsLoanFormApplicationsUuidIndividualPersonParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_INDIVIDUAL_PERSON =
    createEnvVar<TSmeCreditsLoanFormApplicationsUuidIndividualPersonParams>(
        'SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_INDIVIDUAL_PERSON',
        process.env.SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_INDIVIDUAL_PERSON
    );
export type TSmeCreditsLoanFormApplicationsUuidLegalDirectorParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_LEGAL_DIRECTOR =
    createEnvVar<TSmeCreditsLoanFormApplicationsUuidLegalDirectorParams>(
        'SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_LEGAL_DIRECTOR',
        process.env.SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_LEGAL_DIRECTOR
    );
export type TSmeCreditsLoanFormApplicationsUuidLegalPersonParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_LEGAL_PERSON =
    createEnvVar<TSmeCreditsLoanFormApplicationsUuidLegalPersonParams>(
        'SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_LEGAL_PERSON',
        process.env.SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_LEGAL_PERSON
    );
export type TSmeCreditsLoanFormApplicationsUuidSendToManagerParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_SEND_TO_MANAGER =
    createEnvVar<TSmeCreditsLoanFormApplicationsUuidSendToManagerParams>(
        'SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_SEND_TO_MANAGER',
        process.env.SME_CREDITS_LOAN_FORM_APPLICATIONS_UUID_SEND_TO_MANAGER
    );
export const SME_CREDITS_LOAN_FORM_AUTHENTICATION = createEnvVar(
    'SME_CREDITS_LOAN_FORM_AUTHENTICATION',
    process.env.SME_CREDITS_LOAN_FORM_AUTHENTICATION
);
export const SME_CREDITS_LOAN_FORM_COMPANIES_OKVED = createEnvVar(
    'SME_CREDITS_LOAN_FORM_COMPANIES_OKVED',
    process.env.SME_CREDITS_LOAN_FORM_COMPANIES_OKVED
);
export type TSmeCreditsLoanFormCreateAppLoanmbParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_CREATE_APP_LOANMB =
    createEnvVar<TSmeCreditsLoanFormCreateAppLoanmbParams>(
        'SME_CREDITS_LOAN_FORM_CREATE_APP_LOANMB',
        process.env.SME_CREDITS_LOAN_FORM_CREATE_APP_LOANMB
    );
export const SME_CREDITS_LOAN_FORM_DELIVERIES_RKO_ZONES = createEnvVar(
    'SME_CREDITS_LOAN_FORM_DELIVERIES_RKO_ZONES',
    process.env.SME_CREDITS_LOAN_FORM_DELIVERIES_RKO_ZONES
);
export type TSmeCreditsLoanFormDocumentParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_DOCUMENT = createEnvVar<TSmeCreditsLoanFormDocumentParams>(
    'SME_CREDITS_LOAN_FORM_DOCUMENT',
    process.env.SME_CREDITS_LOAN_FORM_DOCUMENT
);
export type TSmeCreditsLoanFormDocumentSignParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_DOCUMENT_SIGN =
    createEnvVar<TSmeCreditsLoanFormDocumentSignParams>(
        'SME_CREDITS_LOAN_FORM_DOCUMENT_SIGN',
        process.env.SME_CREDITS_LOAN_FORM_DOCUMENT_SIGN
    );
export type TSmeCreditsLoanFormDocumentSignInitParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_DOCUMENT_SIGN_INIT =
    createEnvVar<TSmeCreditsLoanFormDocumentSignInitParams>(
        'SME_CREDITS_LOAN_FORM_DOCUMENT_SIGN_INIT',
        process.env.SME_CREDITS_LOAN_FORM_DOCUMENT_SIGN_INIT
    );
export type TSmeCreditsLoanFormFullScoringParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_FULL_SCORING =
    createEnvVar<TSmeCreditsLoanFormFullScoringParams>(
        'SME_CREDITS_LOAN_FORM_FULL_SCORING',
        process.env.SME_CREDITS_LOAN_FORM_FULL_SCORING
    );
export type TSmeCreditsLoanFormGetApplicationDataParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_GET_APPLICATION_DATA =
    createEnvVar<TSmeCreditsLoanFormGetApplicationDataParams>(
        'SME_CREDITS_LOAN_FORM_GET_APPLICATION_DATA',
        process.env.SME_CREDITS_LOAN_FORM_GET_APPLICATION_DATA
    );
export type TSmeCreditsLoanFormPassportsParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_PASSPORTS = createEnvVar<TSmeCreditsLoanFormPassportsParams>(
    'SME_CREDITS_LOAN_FORM_PASSPORTS',
    process.env.SME_CREDITS_LOAN_FORM_PASSPORTS
);
export const SME_CREDITS_LOAN_FORM_REQUEST_CODE = createEnvVar(
    'SME_CREDITS_LOAN_FORM_REQUEST_CODE',
    process.env.SME_CREDITS_LOAN_FORM_REQUEST_CODE
);
export type TSmeCreditsLoanFormSaveLegalCompanyDataParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_SAVE_LEGAL_COMPANY_DATA =
    createEnvVar<TSmeCreditsLoanFormSaveLegalCompanyDataParams>(
        'SME_CREDITS_LOAN_FORM_SAVE_LEGAL_COMPANY_DATA',
        process.env.SME_CREDITS_LOAN_FORM_SAVE_LEGAL_COMPANY_DATA
    );
export type TSmeCreditsLoanFormSaveLegalIndividualCompanyDataParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_SAVE_LEGAL_INDIVIDUAL_COMPANY_DATA =
    createEnvVar<TSmeCreditsLoanFormSaveLegalIndividualCompanyDataParams>(
        'SME_CREDITS_LOAN_FORM_SAVE_LEGAL_INDIVIDUAL_COMPANY_DATA',
        process.env.SME_CREDITS_LOAN_FORM_SAVE_LEGAL_INDIVIDUAL_COMPANY_DATA
    );
export type TSmeCreditsLoanFormScoringParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_SCORING = createEnvVar<TSmeCreditsLoanFormScoringParams>(
    'SME_CREDITS_LOAN_FORM_SCORING',
    process.env.SME_CREDITS_LOAN_FORM_SCORING
);
export type TSmeCreditsLoanFormSendOfferParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_SEND_OFFER = createEnvVar<TSmeCreditsLoanFormSendOfferParams>(
    'SME_CREDITS_LOAN_FORM_SEND_OFFER',
    process.env.SME_CREDITS_LOAN_FORM_SEND_OFFER
);
export type TSmeCreditsLoanFormSendToCallbackParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_SEND_TO_CALLBACK =
    createEnvVar<TSmeCreditsLoanFormSendToCallbackParams>(
        'SME_CREDITS_LOAN_FORM_SEND_TO_CALLBACK',
        process.env.SME_CREDITS_LOAN_FORM_SEND_TO_CALLBACK
    );
export type TSmeCreditsLoanFormSendToNibParams = {
    uuid: string | number;
};
export const SME_CREDITS_LOAN_FORM_SEND_TO_NIB = createEnvVar<TSmeCreditsLoanFormSendToNibParams>(
    'SME_CREDITS_LOAN_FORM_SEND_TO_NIB',
    process.env.SME_CREDITS_LOAN_FORM_SEND_TO_NIB
);
export const SME_CREDITS_LOAN_FORM_SHORT_APP_SAVE = createEnvVar(
    'SME_CREDITS_LOAN_FORM_SHORT_APP_SAVE',
    process.env.SME_CREDITS_LOAN_FORM_SHORT_APP_SAVE
);
export type TSmeCreditsPrescoringParams = {
    uuid: string | number;
};
export const SME_CREDITS_PRESCORING = createEnvVar<TSmeCreditsPrescoringParams>(
    'SME_CREDITS_PRESCORING',
    process.env.SME_CREDITS_PRESCORING
);
export const SME_CREDITS_PRESCORING_APPLICATION_SAVE = createEnvVar(
    'SME_CREDITS_PRESCORING_APPLICATION_SAVE',
    process.env.SME_CREDITS_PRESCORING_APPLICATION_SAVE
);
export type TSmeCreditsPrescoringCallbackParams = {
    uuid: string | number;
};
export const SME_CREDITS_PRESCORING_CALLBACK = createEnvVar<TSmeCreditsPrescoringCallbackParams>(
    'SME_CREDITS_PRESCORING_CALLBACK',
    process.env.SME_CREDITS_PRESCORING_CALLBACK
);
export const SME_CREDITS_PRESCORING_CITIES_OF_PRESENCE = createEnvVar(
    'SME_CREDITS_PRESCORING_CITIES_OF_PRESENCE',
    process.env.SME_CREDITS_PRESCORING_CITIES_OF_PRESENCE
);
export const SME_CREDITS_PRESCORING_CODE_REQUEST = createEnvVar(
    'SME_CREDITS_PRESCORING_CODE_REQUEST',
    process.env.SME_CREDITS_PRESCORING_CODE_REQUEST
);
export const SME_CREDITS_PRESCORING_CODE_VERIFY = createEnvVar(
    'SME_CREDITS_PRESCORING_CODE_VERIFY',
    process.env.SME_CREDITS_PRESCORING_CODE_VERIFY
);
export const SME_CREDIT_MEDIUM_BUSINESS_APPLICATIONS_INIT = createEnvVar(
    'SME_CREDIT_MEDIUM_BUSINESS_APPLICATIONS_INIT',
    process.env.SME_CREDIT_MEDIUM_BUSINESS_APPLICATIONS_INIT
);
export type TSmeCreditMediumBusinessApplicationsUuidParams = {
    uuid: string | number;
};
export const SME_CREDIT_MEDIUM_BUSINESS_APPLICATIONS_UUID =
    createEnvVar<TSmeCreditMediumBusinessApplicationsUuidParams>(
        'SME_CREDIT_MEDIUM_BUSINESS_APPLICATIONS_UUID',
        process.env.SME_CREDIT_MEDIUM_BUSINESS_APPLICATIONS_UUID
    );
export type TSmeCreditMediumBusinessApplicationsUuidSendToCallQueueParams = {
    uuid: string | number;
};
export const SME_CREDIT_MEDIUM_BUSINESS_APPLICATIONS_UUID_SEND_TO_CALL_QUEUE =
    createEnvVar<TSmeCreditMediumBusinessApplicationsUuidSendToCallQueueParams>(
        'SME_CREDIT_MEDIUM_BUSINESS_APPLICATIONS_UUID_SEND_TO_CALL_QUEUE',
        process.env.SME_CREDIT_MEDIUM_BUSINESS_APPLICATIONS_UUID_SEND_TO_CALL_QUEUE
    );
export const SME_CREDIT_MEDIUM_BUSINESS_AUTHENTICATION = createEnvVar(
    'SME_CREDIT_MEDIUM_BUSINESS_AUTHENTICATION',
    process.env.SME_CREDIT_MEDIUM_BUSINESS_AUTHENTICATION
);
export const SME_CREDIT_MEDIUM_BUSINESS_CODES_REQUEST = createEnvVar(
    'SME_CREDIT_MEDIUM_BUSINESS_CODES_REQUEST',
    process.env.SME_CREDIT_MEDIUM_BUSINESS_CODES_REQUEST
);
export type TSmeCreditMediumBusinessOfferingProcessParams = {
    uuid: string | number;
};
export const SME_CREDIT_MEDIUM_BUSINESS_OFFERING_PROCESS =
    createEnvVar<TSmeCreditMediumBusinessOfferingProcessParams>(
        'SME_CREDIT_MEDIUM_BUSINESS_OFFERING_PROCESS',
        process.env.SME_CREDIT_MEDIUM_BUSINESS_OFFERING_PROCESS
    );
export const SME_CREDIT_PERSONAL_OFFICE_APPLICATIONS_CUSTOMER = createEnvVar(
    'SME_CREDIT_PERSONAL_OFFICE_APPLICATIONS_CUSTOMER',
    process.env.SME_CREDIT_PERSONAL_OFFICE_APPLICATIONS_CUSTOMER
);
export const SME_CREDIT_PERSONAL_OFFICE_LOGOUT = createEnvVar(
    'SME_CREDIT_PERSONAL_OFFICE_LOGOUT',
    process.env.SME_CREDIT_PERSONAL_OFFICE_LOGOUT
);
export const SME_CREDIT_RB_SIGN_MODULE_UI = createEnvVar(
    'SME_CREDIT_RB_SIGN_MODULE_UI',
    process.env.SME_CREDIT_RB_SIGN_MODULE_UI
);
export type TSmeDcFormSenderRkoKaDraftDeliveryParams = {
    appUuid: string | number;
};
export const SME_DC_FORM_SENDER_RKO_KA_DRAFT_DELIVERY =
    createEnvVar<TSmeDcFormSenderRkoKaDraftDeliveryParams>(
        'SME_DC_FORM_SENDER_RKO_KA_DRAFT_DELIVERY',
        process.env.SME_DC_FORM_SENDER_RKO_KA_DRAFT_DELIVERY
    );
export type TSmeDcFormSenderRkoKaInitDeliveryParams = {
    appUuid: string | number;
};
export const SME_DC_FORM_SENDER_RKO_KA_INIT_DELIVERY =
    createEnvVar<TSmeDcFormSenderRkoKaInitDeliveryParams>(
        'SME_DC_FORM_SENDER_RKO_KA_INIT_DELIVERY',
        process.env.SME_DC_FORM_SENDER_RKO_KA_INIT_DELIVERY
    );
export type TSmeDcFormSenderRkoPaDeliveryParams = {
    availableDaysForPreview: string | number;
    dateFrom: string | number;
    dateTo: string | number;
    latitude: string | number;
    longitude: string | number;
};
export const SME_DC_FORM_SENDER_RKO_PA_DELIVERY = createEnvVar<TSmeDcFormSenderRkoPaDeliveryParams>(
    'SME_DC_FORM_SENDER_RKO_PA_DELIVERY',
    process.env.SME_DC_FORM_SENDER_RKO_PA_DELIVERY
);
export const SME_DEPOSIT_BIS_DEPOSITS = createEnvVar(
    'SME_DEPOSIT_BIS_DEPOSITS',
    process.env.SME_DEPOSIT_BIS_DEPOSITS
);
export const SME_DM_FORM_SENDER_RKO_DELIVERIES = createEnvVar(
    'SME_DM_FORM_SENDER_RKO_DELIVERIES',
    process.env.SME_DM_FORM_SENDER_RKO_DELIVERIES
);
export type TSmeDmFormSenderRkoDeliveryParams = {
    deliveryUuid: string | number;
};
export const SME_DM_FORM_SENDER_RKO_DELIVERY = createEnvVar<TSmeDmFormSenderRkoDeliveryParams>(
    'SME_DM_FORM_SENDER_RKO_DELIVERY',
    process.env.SME_DM_FORM_SENDER_RKO_DELIVERY
);
export type TSmeDmFormSenderRkoDeliveryInfoParams = {
    deliveryUuid: string | number;
};
export const SME_DM_FORM_SENDER_RKO_DELIVERY_INFO =
    createEnvVar<TSmeDmFormSenderRkoDeliveryInfoParams>(
        'SME_DM_FORM_SENDER_RKO_DELIVERY_INFO',
        process.env.SME_DM_FORM_SENDER_RKO_DELIVERY_INFO
    );
export const SME_DM_FORM_SENDER_RKO_LOGOUT = createEnvVar(
    'SME_DM_FORM_SENDER_RKO_LOGOUT',
    process.env.SME_DM_FORM_SENDER_RKO_LOGOUT
);
export const SME_DM_FORM_SENDER_RKO_RESCHEDULING_REASONS = createEnvVar(
    'SME_DM_FORM_SENDER_RKO_RESCHEDULING_REASONS',
    process.env.SME_DM_FORM_SENDER_RKO_RESCHEDULING_REASONS
);
export const SME_FORM_HOST = createEnvVar('SME_FORM_HOST', process.env.SME_FORM_HOST);
export const SME_FORM_SENDER_SUZ_FULL = createEnvVar(
    'SME_FORM_SENDER_SUZ_FULL',
    process.env.SME_FORM_SENDER_SUZ_FULL
);
export const SME_FORM_SENDER_SUZ_REQUEST = createEnvVar(
    'SME_FORM_SENDER_SUZ_REQUEST',
    process.env.SME_FORM_SENDER_SUZ_REQUEST
);
export type TSmeLawAdviseGetApplicationsParams = {
    uuid: string | number;
};
export const SME_LAW_ADVISE_GET_APPLICATIONS = createEnvVar<TSmeLawAdviseGetApplicationsParams>(
    'SME_LAW_ADVISE_GET_APPLICATIONS',
    process.env.SME_LAW_ADVISE_GET_APPLICATIONS
);
export const SME_LAW_ADVISE_PAYMENT_TOKEN = createEnvVar(
    'SME_LAW_ADVISE_PAYMENT_TOKEN',
    process.env.SME_LAW_ADVISE_PAYMENT_TOKEN
);
export type TSmeLawAdvisePostApplicationsAuthenticationParams = {
    uuid: string | number;
};
export const SME_LAW_ADVISE_POST_APPLICATIONS_AUTHENTICATION =
    createEnvVar<TSmeLawAdvisePostApplicationsAuthenticationParams>(
        'SME_LAW_ADVISE_POST_APPLICATIONS_AUTHENTICATION',
        process.env.SME_LAW_ADVISE_POST_APPLICATIONS_AUTHENTICATION
    );
export type TSmeLawAdvisePostApplicationsIdentificationParams = {
    uuid: string | number;
};
export const SME_LAW_ADVISE_POST_APPLICATIONS_IDENTIFICATION =
    createEnvVar<TSmeLawAdvisePostApplicationsIdentificationParams>(
        'SME_LAW_ADVISE_POST_APPLICATIONS_IDENTIFICATION',
        process.env.SME_LAW_ADVISE_POST_APPLICATIONS_IDENTIFICATION
    );
export const SME_LAW_ADVISE_POST_APPLICATIONS_INIT = createEnvVar(
    'SME_LAW_ADVISE_POST_APPLICATIONS_INIT',
    process.env.SME_LAW_ADVISE_POST_APPLICATIONS_INIT
);
export type TSmeLawAdvisePostApplicationsPaymentPrepareParams = {
    uuid: string | number;
};
export const SME_LAW_ADVISE_POST_APPLICATIONS_PAYMENT_PREPARE =
    createEnvVar<TSmeLawAdvisePostApplicationsPaymentPrepareParams>(
        'SME_LAW_ADVISE_POST_APPLICATIONS_PAYMENT_PREPARE',
        process.env.SME_LAW_ADVISE_POST_APPLICATIONS_PAYMENT_PREPARE
    );
export type TSmeLawAdvisePostApplicationsRegistrationParams = {
    uuid: string | number;
};
export const SME_LAW_ADVISE_POST_APPLICATIONS_REGISTRATION =
    createEnvVar<TSmeLawAdvisePostApplicationsRegistrationParams>(
        'SME_LAW_ADVISE_POST_APPLICATIONS_REGISTRATION',
        process.env.SME_LAW_ADVISE_POST_APPLICATIONS_REGISTRATION
    );
export const SME_NALOG_RU_INN_PROC = createEnvVar(
    'SME_NALOG_RU_INN_PROC',
    process.env.SME_NALOG_RU_INN_PROC
);
export const SME_PARTNERS_OFFERS = createEnvVar(
    'SME_PARTNERS_OFFERS',
    process.env.SME_PARTNERS_OFFERS
);
export type TSmePartnersOffersDetailParams = {
    offerId: string | number;
};
export const SME_PARTNERS_OFFERS_DETAIL = createEnvVar<TSmePartnersOffersDetailParams>(
    'SME_PARTNERS_OFFERS_DETAIL',
    process.env.SME_PARTNERS_OFFERS_DETAIL
);
export type TSmePartnersOffersSimilarParams = {
    offerId: string | number;
};
export const SME_PARTNERS_OFFERS_SIMILAR = createEnvVar<TSmePartnersOffersSimilarParams>(
    'SME_PARTNERS_OFFERS_SIMILAR',
    process.env.SME_PARTNERS_OFFERS_SIMILAR
);
export const SME_PAYMENT_SCRIPT = createEnvVar(
    'SME_PAYMENT_SCRIPT',
    process.env.SME_PAYMENT_SCRIPT
);
export const SME_PROD_ENV = createEnvVar('SME_PROD_ENV', process.env.SME_PROD_ENV);
export const SME_REQUEST_PRESCORING_RESULT_INTERVAL_DEFAULT = createEnvVar(
    'SME_REQUEST_PRESCORING_RESULT_INTERVAL_DEFAULT',
    process.env.SME_REQUEST_PRESCORING_RESULT_INTERVAL_DEFAULT
);
export type TSmeRevizorApplicationsSubscriptionsParams = {
    appUuid: string | number;
};
export const SME_REVIZOR_APPLICATIONS_SUBSCRIPTIONS =
    createEnvVar<TSmeRevizorApplicationsSubscriptionsParams>(
        'SME_REVIZOR_APPLICATIONS_SUBSCRIPTIONS',
        process.env.SME_REVIZOR_APPLICATIONS_SUBSCRIPTIONS
    );
export const SME_REVIZOR_GET_ORDER_ID = createEnvVar(
    'SME_REVIZOR_GET_ORDER_ID',
    process.env.SME_REVIZOR_GET_ORDER_ID
);
export const SME_REVIZOR_TOKEN = createEnvVar('SME_REVIZOR_TOKEN', process.env.SME_REVIZOR_TOKEN);
export const SME_TESTDRIVE_APPLICATIONS_INIT = createEnvVar(
    'SME_TESTDRIVE_APPLICATIONS_INIT',
    process.env.SME_TESTDRIVE_APPLICATIONS_INIT
);
export type TSmeTestdriveAuthenticateParams = {
    uuid: string | number;
};
export const SME_TESTDRIVE_AUTHENTICATE = createEnvVar<TSmeTestdriveAuthenticateParams>(
    'SME_TESTDRIVE_AUTHENTICATE',
    process.env.SME_TESTDRIVE_AUTHENTICATE
);
export type TSmeTestdriveIdentificateParams = {
    uuid: string | number;
};
export const SME_TESTDRIVE_IDENTIFICATE = createEnvVar<TSmeTestdriveIdentificateParams>(
    'SME_TESTDRIVE_IDENTIFICATE',
    process.env.SME_TESTDRIVE_IDENTIFICATE
);
export type TSmeTestdriveLoginParams = {
    uuid: string | number;
};
export const SME_TESTDRIVE_LOGIN = createEnvVar<TSmeTestdriveLoginParams>(
    'SME_TESTDRIVE_LOGIN',
    process.env.SME_TESTDRIVE_LOGIN
);
export type TSmeTradeGetTariffsParams = {
    limit: string | number;
    offset: string | number;
    sort: string | number;
};
export const SME_TRADE_GET_TARIFFS = createEnvVar<TSmeTradeGetTariffsParams>(
    'SME_TRADE_GET_TARIFFS',
    process.env.SME_TRADE_GET_TARIFFS
);
export type TSmeWebinarProxyRegistrationParams = {
    sessionId: string | number;
};
export const SME_WEBINAR_PROXY_REGISTRATION = createEnvVar<TSmeWebinarProxyRegistrationParams>(
    'SME_WEBINAR_PROXY_REGISTRATION',
    process.env.SME_WEBINAR_PROXY_REGISTRATION
);
export const SME_WEBINAR_PROXY_SCHEDULE_FULL = createEnvVar(
    'SME_WEBINAR_PROXY_SCHEDULE_FULL',
    process.env.SME_WEBINAR_PROXY_SCHEDULE_FULL
);
export const STORYBOOK_DADATA = createEnvVar('STORYBOOK_DADATA', process.env.STORYBOOK_DADATA);
export const TRANBILOG_URL = createEnvVar('TRANBILOG_URL', process.env.TRANBILOG_URL);
export type TVimeoIframeTemplateParams = {
    videoId: string | number;
};
export const VIMEO_IFRAME_TEMPLATE = createEnvVar<TVimeoIframeTemplateParams>(
    'VIMEO_IFRAME_TEMPLATE',
    process.env.VIMEO_IFRAME_TEMPLATE
);
export type TVimeoThumbnailTemplateParams = {
    videoId: string | number;
};
export const VIMEO_THUMBNAIL_TEMPLATE = createEnvVar<TVimeoThumbnailTemplateParams>(
    'VIMEO_THUMBNAIL_TEMPLATE',
    process.env.VIMEO_THUMBNAIL_TEMPLATE
);
export const WEB_DEV_KEY = createEnvVar('WEB_DEV_KEY', process.env.WEB_DEV_KEY);
export const YANDEX_METRIC_STATIC_URL = createEnvVar(
    'YANDEX_METRIC_STATIC_URL',
    process.env.YANDEX_METRIC_STATIC_URL
);
export const YA_MAP_KEY = createEnvVar('YA_MAP_KEY', process.env.YA_MAP_KEY);
export const YA_MAP_SUGGEST_API_KEY = createEnvVar(
    'YA_MAP_SUGGEST_API_KEY',
    process.env.YA_MAP_SUGGEST_API_KEY
);
export type TYoutubeIframeTemplateParams = {
    apiParams: string | number;
    videoId: string | number;
};
export const YOUTUBE_IFRAME_TEMPLATE = createEnvVar<TYoutubeIframeTemplateParams>(
    'YOUTUBE_IFRAME_TEMPLATE',
    process.env.YOUTUBE_IFRAME_TEMPLATE
);
export type TYoutubeThumbnailTemplateParams = {
    videoId: string | number;
};
export const YOUTUBE_THUMBNAIL_TEMPLATE = createEnvVar<TYoutubeThumbnailTemplateParams>(
    'YOUTUBE_THUMBNAIL_TEMPLATE',
    process.env.YOUTUBE_THUMBNAIL_TEMPLATE
);
